import { useState } from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import { toast } from "react-toastify";

import { Button, Container, Grid, Page } from "tabler-react";

import SiteWrapper from "../../SiteWrapper";
import ButtonExport from "../../ui/ButtonExport";
import FinanceInvoicesFilter from "./FinanceInvoicesFilter";
import confirm_reminders from "../../../tools/confirm_reminders";
import { GET_OVERDUE_INVOICES, SEND_INVOICE_REMINDERS } from "./queries";

function FinanceInvoicesBase({ t, history, children, refetch }) {
    const [isSending, setIsSending] = useState(false);

    // Query to get overdue invoices count
    const { data: overdueData } = useQuery(GET_OVERDUE_INVOICES, {
        fetchPolicy: "network-only",
    });

    // Mutation to send reminders
    const [sendReminders] = useMutation(SEND_INVOICE_REMINDERS, {
        onCompleted: (data) => {
            toast.success(t("finance.invoices.reminders_sent_successfully"), {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
            setIsSending(false);
            if (refetch) refetch();
        },
        onError: (error) => {
            toast.error(t("general.error_sad_smiley"), {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
            console.error(error);
            setIsSending(false);
        },
    });

    const handleSendReminders = () => {
        setIsSending(true);
        sendReminders({
            variables: {
                input: {},
            },
        });
    };

    const showSendRemindersConfirmation = () => {
        const overdueCount = overdueData?.overdueInvoicesCount || 0;

        if (overdueCount === 0) {
            toast.info(t("finance.invoices.no_overdue_invoices"), {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
            return;
        }

        confirm_reminders({
            t,
            overdueCount,
            onConfirm: handleSendReminders,
        });
    };

    return (
        <SiteWrapper>
            <div className="my-3 my-md-5">
                <Container>
                    <Page.Header title={t("finance.title")}>
                        <div className="page-options d-flex">
                            <Button
                                color="warning"
                                icon="mail"
                                className="mr-2"
                                onClick={showSendRemindersConfirmation}
                                disabled={isSending}
                            >
                                {isSending
                                    ? t("general.sending")
                                    : t("finance.invoices.send_reminders")}
                            </Button>
                            <ButtonExport
                                url="/finance/invoices/export"
                                className="mr-2"
                            />
                            <Link to="/finance/invoices/groups">
                                <Button color="secondary" icon="folder">
                                    {t("general.groups")}
                                </Button>
                            </Link>
                        </div>
                    </Page.Header>
                    <Grid.Row>
                        <Grid.Col md={12}>
                            <FinanceInvoicesFilter refetch={refetch} />
                            {children}
                        </Grid.Col>
                    </Grid.Row>
                </Container>
            </div>
        </SiteWrapper>
    );
}

export default withTranslation()(withRouter(FinanceInvoicesBase));
